  import Enum from './enum'

class TenderDocumentType extends Enum
{
  constructor(value) {
    super(value);
  }
}

TenderDocumentType.init({
  FOR_REQUEST: 'ForRequest',
  FOR_BID: 'ForBid'
}, {
  FOR_REQUEST: 'tender-document-type.for-request',
  FOR_BID: 'tender-document-type.for-bid'
});

export default TenderDocumentType;
